import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a21f4f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "CompletedCargo" }
const _hoisted_2 = {
  key: 0,
  class: "CompletedCargo__short"
}
const _hoisted_3 = { class: "grid grid-cols-1 xl:grid-cols-3 gap-6" }
const _hoisted_4 = { class: "flex flex-col" }
const _hoisted_5 = { class: "text-blue-600 font-semibold" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "flex flex-col" }
const _hoisted_8 = { class: "flex flex-col" }
const _hoisted_9 = { class: "grid grid-cols-2 gap-x-3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "3", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col" }, null, -1))
const _hoisted_12 = {
  key: 1,
  class: "CompletedCargo__full"
}
const _hoisted_13 = { class: "grid grid-cols-1 xl:grid-cols-3 gap-6 pb-3" }
const _hoisted_14 = { class: "flex flex-col" }
const _hoisted_15 = { class: "text-blue-600 font-semibold" }
const _hoisted_16 = { class: "flex flex-col" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "3", -1))
const _hoisted_18 = { class: "flex flex-col" }
const _hoisted_19 = { class: "grid grid-cols-1 xl:grid-cols-3 gap-6 border-t pt-3" }
const _hoisted_20 = { class: "flex flex-col" }
const _hoisted_21 = { class: "flex flex-col" }
const _hoisted_22 = { class: "grid grid-cols-3 gap-3" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_25 = { class: "text-sm mt-1" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "3", -1))
const _hoisted_27 = { class: "text-sm" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "3", -1))
const _hoisted_29 = { key: 1 }
const _hoisted_30 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_31 = { class: "text-sm mt-1" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "3", -1))
const _hoisted_33 = { class: "text-sm" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "3", -1))
const _hoisted_35 = { key: 2 }
const _hoisted_36 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_37 = { class: "text-sm mt-1" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "3", -1))
const _hoisted_39 = { class: "text-sm" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "3", -1))
const _hoisted_41 = { class: "flex flex-col" }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = {
  key: 2,
  class: "flex flex-col"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Примечания к отправке:", -1))
const _hoisted_46 = { class: "block text-sm text-gray-400 font-semibold" }
const _hoisted_47 = { class: "flex items-center" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash mr-2" }, null, -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen mr-2" }, null, -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-caret-down mr-2" }, null, -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-caret-up mr-2" }, null, -1))
const _hoisted_52 = { class: "mt-4 pt-2 border-t border-gray-200" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Дополнительные услуги при доставке", -1))
const _hoisted_54 = { class: "Checkboxes mt-2" }
const _hoisted_55 = { class: "flex flex-col" }
const _hoisted_56 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_57 = { class: "text-sm mt-1" }
const _hoisted_58 = { class: "text-sm" }
const _hoisted_59 = { class: "flex flex-col" }
const _hoisted_60 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_61 = { class: "text-sm mt-1" }
const _hoisted_62 = { class: "text-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!
  const _component_checkbox = _resolveComponent("checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.state.is_opened)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.cargo.receiver.title), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.cargo.receiver.full_name), 1),
              (_ctx.cargo.deliveryTimeSlot)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Тайм-слот доставки: " + _toDisplayString(_ctx.cargo.deliveryTimeSlot.deliveryDate) + " " + _toDisplayString(_ctx.cargo.deliveryTimeSlot.timeFromTo), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", null, _toDisplayString(_ctx.cargo.receiver.phone), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.cargo.receiver.full_address), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("span", null, "Мест: " + _toDisplayString(_ctx.cargo.logistics_info.places), 1),
                _createElementVNode("span", null, "Вес: " + _toDisplayString(_ctx.cargo.logistics_info.weight) + " кг", 1),
                _createElementVNode("span", null, [
                  _createTextVNode("Объём: " + _toDisplayString(_ctx.cargo.logistics_info.volume) + " м", 1),
                  _hoisted_10
                ]),
                _createElementVNode("span", null, _toDisplayString(_ctx.LTL_SHIPMENT_TYPES_OBJECT[_ctx.cargo.logistics_info.shipment_type]), 1)
              ])
            ]),
            _hoisted_11
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.cargo.receiver.title), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.cargo.receiver.full_name), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.cargo.receiver.phone), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.cargo.receiver.full_address), 1)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("span", null, "Мест: " + _toDisplayString(_ctx.cargo.logistics_info.places), 1),
              _createElementVNode("span", null, "Вес: " + _toDisplayString(_ctx.cargo.logistics_info.weight) + " кг", 1),
              _createElementVNode("span", null, [
                _createTextVNode("Объём: " + _toDisplayString(_ctx.cargo.logistics_info.volume) + " м", 1),
                _hoisted_17
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("span", null, " Тип доставки: " + _toDisplayString(_ctx.LTL_SHIPMENT_TYPES_OBJECT[_ctx.cargo.logistics_info.shipment_type]), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.PAYMENT_TYPES_OBJECT[_ctx.cargo.logistics_info.payment_type]), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.PAYMENT_METHODS_OBJECT[_ctx.cargo.logistics_info.payment_method]), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("span", null, [
                _createTextVNode(" Номер накладной заказчика: "),
                (Boolean(_ctx.cargo.logistics_info.customer_invoice_number))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.cargo.logistics_info.customer_invoice_number), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(" - ")
                    ], 64))
              ]),
              _createElementVNode("span", null, [
                _createTextVNode(" Возвратные документы: "),
                (Boolean(_ctx.cargo.logistics_info.is_return_documents))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(" Да ")
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode("Нет")
                    ], 64))
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("span", null, "Длина: " + _toDisplayString(_ctx.cargo.logistics_info.depth), 1),
              _createElementVNode("span", null, "Ширина: " + _toDisplayString(_ctx.cargo.logistics_info.width), 1),
              _createElementVNode("span", null, "Высота: " + _toDisplayString(_ctx.cargo.logistics_info.height), 1)
            ]),
            _createElementVNode("div", _hoisted_22, [
              (_ctx.cargo.logistics_info.additional_services.hasGrid)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createTextVNode(" Обрешетка "),
                    (_ctx.additionalServices.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          _createElementVNode("span", _hoisted_25, [
                            _createTextVNode(" Мин. " + _toDisplayString(_ctx.getValue('grid', 'minValue')) + " м", 1),
                            _hoisted_26
                          ]),
                          _createElementVNode("span", _hoisted_27, [
                            _createTextVNode(_toDisplayString(_ctx.getValue('grid', 'price')) + " тг/м", 1),
                            _hoisted_28
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.cargo.logistics_info.additional_services.hasPallet)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _createTextVNode(" Паллета "),
                    (_ctx.additionalServices.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                          _createElementVNode("span", _hoisted_31, [
                            _createTextVNode(" Мин. " + _toDisplayString(_ctx.getValue('pallet', 'minValue')) + " м", 1),
                            _hoisted_32
                          ]),
                          _createElementVNode("span", _hoisted_33, [
                            _createTextVNode(_toDisplayString(_ctx.getValue('pallet', 'price')) + " тг/м", 1),
                            _hoisted_34
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.cargo.logistics_info.additional_services.hasSoftPackage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _createTextVNode(" Мягкая упаковка "),
                    (_ctx.additionalServices.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                          _createElementVNode("span", _hoisted_37, [
                            _createTextVNode(" Мин. " + _toDisplayString(_ctx.getValue('soft_package', 'minValue')) + " м", 1),
                            _hoisted_38
                          ]),
                          _createElementVNode("span", _hoisted_39, [
                            _createTextVNode(_toDisplayString(_ctx.getValue('soft_package', 'price')) + " тг/м", 1),
                            _hoisted_40
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_41, [
              (Boolean(_ctx.cargo.logistics_info.cod_payment))
                ? (_openBlock(), _createElementBlock("span", _hoisted_42, " Наложенный платёж: " + _toDisplayString(_ctx.cargo.logistics_info.cod_payment), 1))
                : _createCommentVNode("", true),
              (Boolean(_ctx.cargo.logistics_info.declared_price))
                ? (_openBlock(), _createElementBlock("span", _hoisted_43, " Объявленная стоимость: " + _toDisplayString(_ctx.cargo.logistics_info.declared_price), 1))
                : _createCommentVNode("", true),
              (Boolean(_ctx.cargo.logistics_info.annotation))
                ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                    _hoisted_45,
                    _createElementVNode("p", null, _toDisplayString(_ctx.cargo.logistics_info.annotation), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])),
    _createElementVNode("div", {
      class: _normalizeClass(["flex items-center justify-between", { 'mt-3': _ctx.state.is_opened }])
    }, [
      _createElementVNode("span", _hoisted_46, "№" + _toDisplayString(_ctx.index + 1), 1),
      _createElementVNode("div", _hoisted_47, [
        _createVNode(_component_the_button, {
          class: "red small text mr-2",
          disabled: _ctx.disabled,
          onClick: _ctx.emitDelete
        }, {
          default: _withCtx(() => [
            _hoisted_48,
            _createTextVNode(" Удалить ")
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]),
        _createVNode(_component_the_button, {
          class: "primary small text mr-2",
          disabled: _ctx.disabled,
          onClick: _ctx.emitUpdate
        }, {
          default: _withCtx(() => [
            _hoisted_49,
            _createTextVNode(" Редактировать ")
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]),
        (!_ctx.state.is_opened)
          ? (_openBlock(), _createBlock(_component_the_button, {
              key: 0,
              class: "primary small text",
              onClick: _ctx.open
            }, {
              default: _withCtx(() => [
                _hoisted_50,
                _createTextVNode(" Раскрыть ")
              ]),
              _: 1
            }, 8, ["onClick"]))
          : (_openBlock(), _createBlock(_component_the_button, {
              key: 1,
              class: "primary small text",
              onClick: _ctx.close
            }, {
              default: _withCtx(() => [
                _hoisted_51,
                _createTextVNode(" Скрыть ")
              ]),
              _: 1
            }, 8, ["onClick"]))
      ])
    ], 2),
    _createElementVNode("div", _hoisted_52, [
      _hoisted_53,
      _createElementVNode("div", _hoisted_54, [
        (_ctx.isBosch)
          ? (_openBlock(), _createBlock(_component_checkbox, {
              key: 0,
              disabled: _ctx.disabled,
              label: "Подъем на этаж",
              value: _ctx.state.additional_services.hasRisingToTheFloor,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.additional_services.hasRisingToTheFloor) = $event)),
              onChange: _ctx.emitUpdateAdditionalServices
            }, null, 8, ["disabled", "value", "onChange"]))
          : _createCommentVNode("", true),
        _createVNode(_component_checkbox, {
          disabled: _ctx.disabled,
          label: "Манипулятор",
          value: _ctx.state.additional_services.hasManipulator,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.additional_services.hasManipulator) = $event)),
          onChange: _ctx.emitUpdateAdditionalServices
        }, null, 8, ["disabled", "value", "onChange"]),
        _createVNode(_component_checkbox, {
          disabled: _ctx.disabled,
          label: "Кран",
          value: _ctx.state.additional_services.hasCrane,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.additional_services.hasCrane) = $event)),
          onChange: _ctx.emitUpdateAdditionalServices
        }, null, 8, ["disabled", "value", "onChange"]),
        _createElementVNode("div", _hoisted_55, [
          _createVNode(_component_checkbox, {
            disabled: _ctx.disabled,
            label: "Рохля",
            value: _ctx.state.additional_services.hasHydraulicTrolley,
            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.additional_services.hasHydraulicTrolley) = $event)),
            onChange: _ctx.emitUpdateAdditionalServices
          }, null, 8, ["disabled", "value", "onChange"]),
          (_ctx.additionalServices.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                _createElementVNode("span", _hoisted_57, " Мин. " + _toDisplayString(_ctx.getValue('hydraulic_trolley', 'minValue')) + " часа ", 1),
                _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.getValue('hydraulic_trolley', 'price')) + " тг/час", 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_59, [
          _createVNode(_component_checkbox, {
            disabled: _ctx.disabled,
            label: "Грузчики",
            value: _ctx.state.additional_services.hasLoader,
            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.additional_services.hasLoader) = $event)),
            onChange: _ctx.emitUpdateAdditionalServices
          }, null, 8, ["disabled", "value", "onChange"]),
          (_ctx.additionalServices.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                _createElementVNode("span", _hoisted_61, " Мин. " + _toDisplayString(_ctx.getValue('loader', 'minValue')) + " часа ", 1),
                _createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.getValue('loader', 'price')) + " тг/час", 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}